import {
  Popover,
  PopoverContent,
  PopoverPortal,
  PopoverTrigger
} from "@radix-ui/react-popover";
import { twMerge } from "tailwind-merge";

import type { FooterItemWithPopoverProps } from "../types";

export const FooterItemWithPopover = ({
  isOpen,
  popoverTrigger,
  popoverContent,
  togglePopover,
  isPopoverTriggerOrigin,
  classNamePopoverContent
}: FooterItemWithPopoverProps) => (
  <Popover
    onOpenChange={(open) => {
      // Only open the popover if the click is from the trigger
      // Need to prevent close the popover if the click is from the trigger
      if (open) {
        togglePopover(true);
      }
    }}
    open={isOpen}
  >
    <PopoverTrigger asChild>{popoverTrigger}</PopoverTrigger>
    <PopoverPortal>
      <PopoverContent
        className={twMerge(
          "ml-4 mb-3 rounded-2xl max-w-[240px] z-[1004] bg-white",
          classNamePopoverContent
        )}
        side="right"
        onInteractOutside={(e) => {
          // Close the popover if the click is outside the popover and not from the trigger
          togglePopover(!isPopoverTriggerOrigin(e));
        }}
      >
        {popoverContent}
      </PopoverContent>
    </PopoverPortal>
  </Popover>
);

export default FooterItemWithPopover;
